interface SchemaOrgData {
  '@context': string;
  '@type': string;
  [key: string]: unknown;
}

interface SchemaOrgProps {
  schema: SchemaOrgData;
}

export default function SchemaOrg({ schema }: SchemaOrgProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema, null, 2),
      }}
    />
  );
}